import React from "react";
import FieldInputMask from "../fieldInputMask";

const FieldInputPlacas = ({
  colMd,
  label,
  name,
  onChange,
  value,
  errors,
  required,
  maskVariable = "******",
}) => {
  return (
    <>
      {label && (
        <FieldInputMask
          maskVariable={maskVariable}
          name={name}
          label={label}
          colMd={colMd}
          required={required}
          errors={errors}
          value={value}
          onChange={onChange}
        />
      )}

      {!label && (
        <FieldInputMask
          maskVariable={maskVariable}
          name={name}
          colMd={colMd}
          errors={errors}
          value={value}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default FieldInputPlacas;